<div class="table-responsive" *ngIf="renderCalcul">
  <table class="table table-borderless table-nowrap table-striped">
    <thead class="table-light">
      <tr>
        <th
          scope="col"
          class="time-column"
          style="
            min-width: 60px !important;
            max-width: 150px !important;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
        >
        </th>
        <ng-container
          *ngFor="
            let productId of selectedProductIds
              | sortedIdsByDescription : (productEntities$ | async)
          "
        >
          <th
            scope="col"
            *ngIf="dependantProductsMap[productId]"
            style="
              min-width: 60px !important;
              max-width: 150px !important;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
          >
            <!-- <span *ngIf="productId">( {{ productId }} )</span> -->
            {{
              (productEntities$ | async)[productId]?.description ??
                (productId | getTranslation : 'product' : 'description' | async)
            }}
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let hour of hours" class="serie-proposal-schedule-row">
        <td>{{ hour }}</td>
        <ng-container
          *ngFor="
            let productId of selectedProductIds
              | sortedIdsByDescription : (productEntities$ | async)
          "
        >
          <td *ngIf="dependantProductsMap[productId]" class="position-relative">
            <div
              *ngFor="
                let proposal of productId
                  | getProposalsForProductAndHour
                    : hour
                    : (productEntities$ | async)
                    : selectedDay
                    : serieProposals
                    : dependantProductsMap
                    : (serieProposalItemEntities$ | async)
              "
            >
              <div
                data-tooltip="# {{ proposal.id }}  {{
                  (organizationEntities$ | async)[proposal.organizationId]
                    ?.description ??
                    (organizationEntities$ | async)[proposal.organizationId]
                      ?.abbreviation
                }}  ( {{ proposal.startTime }}-{{ proposal.endTime }} )"
                class="serie-proposal-div p-2"
                [ngClass]="{
                  'serie-proposal-requested':
                    proposal.finalStatus == serieProposalStatus.REQUESTED,
                  'serie-proposal-counter-proposal':
                    proposal.finalStatus ==
                    serieProposalStatus.COUNTER_PROPOSAL,
                  'serie-proposal-accepted':
                    proposal.finalStatus == serieProposalStatus.ACCEPTED,
                  'serie-proposal-declined':
                    proposal.finalStatus == serieProposalStatus.DECLINED,
                  'serie-proposal-div-conflict':
                    proposal.hasConflict &&
                    proposal.finalStatus !== serieProposalStatus.ACCEPTED,
                  'hours-disabled':
                    (proposal.status === null || proposal.blocked) &&
                    proposal.linkedProductId &&
                    proposal.hasConflict === false,
                  'dependant-product-style':
                    !proposal.status &&
                    proposal.blocked &&
                    !proposal.linkedProductId
                }"
                [ngStyle]="{
                  height: getHeight(proposal),
                  top: getTop(proposal),
                  width: 100 / proposal.conflictGroup + '%',
                  left:
                    proposal.positionInConflictGroup *
                      (100 / proposal.conflictGroup) +
                    '%'
                }"
                (click)="onSerieProposalClick(proposal)"
                (keyup.enter)="onSerieProposalClick(proposal)"
                tabindex="0"
                role="button"
              >
                <i
                  role="img"
                  class="fa me-2"
                  [ngClass]="{
                    'fa-clock':
                      proposal.finalStatus == serieProposalStatus.REQUESTED,
                    'fa-check':
                      proposal.finalStatus == serieProposalStatus.ACCEPTED,
                    'fa-sync-alt':
                      proposal.finalStatus ==
                      serieProposalStatus.COUNTER_PROPOSAL,
                    'fa-times-circle':
                      proposal.finalStatus == serieProposalStatus.DECLINED,
                    'fa-ban': proposal.blocked && proposal.finalStatus,
                    'fa-link': proposal.finalStatus === null
                  }"
                ></i>
                <i
                  role="img"
                  *ngIf="
                    proposal.hasConflict &&
                    proposal.finalStatus !== serieProposalStatus.ACCEPTED
                  "
                  class="fa fa-exclamation-triangle me-2"
                ></i>
                {{ proposal.id }}
                <strong *ngIf="!proposal.blocked">
                  {{
                    (organizationEntities$ | async)[proposal.organizationId]
                      ?.abbreviation ??
                      (organizationEntities$ | async)[proposal.organizationId]
                        ?.description
                  }}
                  ({{ (getSerieProposalItems$(proposal) | async)?.length }})
                </strong>
                -
                {{
                  (proposal.linkedProductId
                    | getTranslation : 'product' : 'description'
                    | async) ||
                    (productEntities$ | async)[proposal.linkedProductId]
                      ?.description
                }}
                <br />
                {{ proposal.startTime }} - {{ proposal.endTime }}
                <br />
                <span
                  *ngIf="messageService.hasNewMessage(proposal)"
                  class="badge bg-primary"
                >
                  {{ 'serieProposalModule.newMessage' | translate }}
                </span>
              </div>
            </div>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
<div
  class="spinner-border"
  role="status"
  attr.aria-label="{{ 'general.loading' | translate }}"
  *ngIf="!renderCalcul"
>
</div>
